import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { X } from 'lucide-react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const NotesDrawerLoader = ({ onClose }) => {
  const { colors } = useTheme();

  return (
    <Flex flexDirection="column" flexGrow="1" width="100%">
      <Flex
        as="header"
        alignItems="center"
        justifyContent="space-between"
        height="40px"
        px="4px"
        sx={{ borderBottom: '1px solid', borderColor: 'border.subtle' }}
      >
        <Flex
          data-testid="close-button"
          alignItems="center"
          justifyContent="center"
          width="40px"
          height="40px"
          color="neutral.400"
          sx={{ cursor: 'pointer' }}
          onClick={onClose}
        >
          <Box as={X} width="16px" height="16px" aria-hidden="true" />
        </Flex>
      </Flex>
      <Box p="16px">
        <ContentLoader
          speed={2}
          width={400}
          height={160}
          viewBox="0 0 400 160"
          backgroundColor={colors.neutral[50]}
          foregroundColor={colors.neutral[20]}
        >
          <rect x="0" y="0" rx="4" ry="4" width="80" height="10" />
          <rect x="0" y="20" rx="4" ry="4" width="300" height="8" />
          <rect x="0" y="40" rx="4" ry="4" width="250" height="8" />
          <rect x="0" y="60" rx="4" ry="4" width="280" height="8" />
          <rect x="0" y="100" rx="4" ry="4" width="60" height="10" />
          <rect x="0" y="120" rx="4" ry="4" width="320" height="8" />
          <rect x="0" y="140" rx="4" ry="4" width="200" height="8" />
        </ContentLoader>
      </Box>
    </Flex>
  );
};

NotesDrawerLoader.propTypes = {
  onClose: PropTypes.func.isRequired,
};
